/*
 * Module for the context menu.  The design may change in the future, but for
 * now, let's just assume there will be only one menu item in the menu.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/header/contextMenu/contextMenuView",
  "modules/header/contextMenu/contextMenuModel",
], function (Marionette, Messenger, ContextMenuView, ContextMenuModel) {
  var MenuBarController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contextMenu";
      this.region = options.region;
      //get items for context menu
      this.menuItems = Messenger.reqres.request("context:menu:items");
      this._setUpVents();
    },
    show: function () {
      this.view = new ContextMenuView.contextMenuView({ collection: this.menuItems });
      this.view.on(
        "itemview:click:menu",
        function (clickedView) {
          Messenger.save(function (success) {
            if (success) {
              var clickedName = clickedView.model.get("name");
              switch (clickedName) {
                case "addTopic":
                  Messenger.vent.trigger("add:topic");
                  break;
              }
            }
          }, this);
        },
        this,
      );
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:context:menu",
        function (menuName) {
          //hide any showing context menu items because only one context item can show at a time
          var contextMenu = this.menuItems.findWhere({ hidden: false });
          if (contextMenu) {
            contextMenu.set("hidden", true);
          }
          //find the menu item and show it
          var menuItem = this.menuItems.findWhere({ name: menuName });
          menuItem.set("hidden", false);
        },
        this,
      );

      Messenger.vent.on(
        "hide:context:menu",
        function () {
          //find the menu item and hide it
          var menuItem = this.menuItems.findWhere({ hidden: false });
          if (menuItem) {
            menuItem.set("hidden", true);
          }
        },
        this,
      );
    },
  });

  return MenuBarController;
});
